export const ROL_CLIENTE = {
  EMISOR: 'Emisor',
  DEUDOR: 'Deudor',
  FONDEADOR: 'Fondeador'
} as const;

export type RolCliente = typeof ROL_CLIENTE[keyof typeof ROL_CLIENTE];
